package com.milta.web

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLStyleElement

private const val SPIN_STYLE_ID = "milta-web-spin-keyframes"
private const val SPIN_ANIMATION_NAME = "milta-spin"

/** Injecte le `@keyframes` de rotation une seule fois dans `<head>` via le DOM brut — l'API
 * `StyleSheet`/`keyframes` de Compose HTML n'est pas disponible dans la version utilisée ici
 * (`Style(rulesBuild: StyleSheetBuilder.() -> Unit)` n'expose aucun constructeur de keyframes),
 * donc on contourne en manipulant `document.head` directement plutôt que l'abstraction Compose.
 * Monté une fois à la racine persistante du dashboard ([DashboardShell]). */
@Composable
internal fun WebSpinnerStyle() {
    DisposableEffect(Unit) {
        if (document.getElementById(SPIN_STYLE_ID) == null) {
            val style = document.createElement("style") as HTMLStyleElement
            style.id = SPIN_STYLE_ID
            style.textContent = "@keyframes $SPIN_ANIMATION_NAME { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }"
            document.head?.appendChild(style)
        }
        onDispose { }
    }
}

/** Spinner CSS pur (anneau + rotation) — pas de Material Icons/Canvas ici : webApp est du DOM pur
 * (Compose HTML), aucun backend Skia pour rendre un `ImageVector`, voir
 * [[documentation:webapp-target-is-kotlin-js-not-wasm]]. Nécessite [WebSpinnerStyle] monté une fois
 * en amont dans l'arbre (déjà fait par [DashboardShell]) pour que l'animation existe. */
@Composable
internal fun WebSpinner(size: Int = 28, strokeWidth: Int = 3, color: String = WebPrimaryMid, trackColor: String = WebSurfaceDim) {
    Div(
        attrs = {
            style {
                width(size.px); height(size.px)
                property("border-radius", "50%")
                property("border", "${strokeWidth}px solid $trackColor")
                property("border-top-color", color)
                property("animation", "$SPIN_ANIMATION_NAME 0.7s linear infinite")
                property("box-sizing", "border-box")
            }
        },
    )
}
